// English Translations
export const en = {
  // Common
  common: {
    dashboard: 'Dashboard',
    home: 'Home',
    profile: 'Profile',
    settings: 'Settings',
    logout: 'Logout',
    login: 'Login',
    signup: 'Sign Up',
    cancel: 'Cancel',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    close: 'Close',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    submit: 'Submit',
    search: 'Search',
    filter: 'Filter',
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    confirm: 'Confirm',
    yes: 'Yes',
    no: 'No',
    ok: 'OK'
  },
  
  // Dashboard
  dashboard: {
    welcome: 'Welcome',
    overview: 'Overview',
    appointments: 'Appointments',
    prescriptions: 'Prescriptions',
    reports: 'Reports',
    subscriptions: 'Subscriptions',
    orders: 'Orders',
    cart: 'Cart',
    notifications: 'Notifications',
    noNotifications: 'No notifications',
    viewAll: 'View All',
    markAllAsRead: 'Mark All as Read',
    hello: 'Hello',
    there: 'there',
    howAreYouFeeling: 'How are you feeling today?',
    yourDoctor: 'Your Doctor',
    yourData: 'Your Data',
    change: 'Change',
    videoConsultation: 'Video Consultation',
    joinCall: 'Join Call',
    message: 'Message',
    call: 'Call',
    noAssignedDoctor: 'No assigned doctor',
    findDoctor: 'Find Doctor',
    weight: 'Weight',
    height: 'Height',
    blood: 'Blood',
    age: 'Age',
    phone: 'Phone',
    address: 'Address',
    generalPractitioner: 'General Practitioner',
    kg: 'kg',
    m: 'm',
    years: 'years',
    yearsOld: 'years old',
    noData: 'N/A',
    healthRecords: 'Health Records',
    marketplace: 'Marketplace',
    services: 'Services',
    billing: 'Billing',
    lightMode: 'Light Mode',
    darkMode: 'Dark Mode',
    diagnostic: 'Diagnostic',
    listOfDiseases: 'List of diseases',
    myDrugs: 'My Drugs',
    prescribedMedicine: 'Prescribed medicine',
    tests: 'Tests',
    labTestResults: 'Lab test results',
    switchToLightMode: 'Switch to Light Mode',
    switchToDarkMode: 'Switch to Dark Mode',
    bookNewAppointment: 'Book New Appointment',
    bookAppointment: 'Book appointment',
    joinVideoCall: 'Join Video Call',
    cancelAppointment: 'Cancel Appointment',
    cancelling: 'Cancelling...',
    noAppointmentsScheduled: 'No Appointments Scheduled',
    noAppointmentsMessage: 'You don\'t have any upcoming appointments. Book your first appointment to get started with your healthcare journey.',
    type: 'Type',
    fee: 'Fee',
    videoConsultation: 'Video Consultation',
    inPersonVisit: 'In-Person Visit',
    areYouSureCancel: 'Are you sure you want to cancel this appointment?',
    appointmentCancelled: 'Appointment cancelled successfully',
    errorCancelling: 'Error cancelling appointment',
    connectedTo: 'Connected to',
    agent: 'Agent',
    waitingForAgent: 'Waiting for an agent...',
    liveChat: 'Live Chat',
    endChat: 'End Chat',
    noMessagesYet: 'No messages yet.',
    typeYourMessage: 'Type your message...',
    send: 'Send',
    addImage: 'Add Image',
    sendImage: 'Send Image',
    remove: 'Remove'
  },
  
  // Appointments
  appointments: {
    title: 'Appointments',
    upcoming: 'Upcoming Appointments',
    past: 'Past Appointments',
    bookAppointment: 'Book Appointment',
    cancelAppointment: 'Cancel Appointment',
    appointmentDetails: 'Appointment Details',
    doctor: 'Doctor',
    date: 'Date',
    time: 'Time',
    status: 'Status',
    pending: 'Pending',
    confirmed: 'Confirmed',
    completed: 'Completed',
    cancelled: 'Cancelled'
  },
  
  // Orders
  orders: {
    title: 'My Orders',
    orderId: 'Order ID',
    orderDate: 'Order Date',
    total: 'Total',
    status: 'Status',
    viewDetails: 'View Details',
    noOrders: 'No orders found',
    pending: 'Pending',
    processing: 'Processing',
    shipped: 'Shipped',
    delivered: 'Delivered',
    cancelled: 'Cancelled'
  },
  
  // Payment
  payment: {
    title: 'Payment',
    amount: 'Amount',
    paymentMethod: 'Payment Method',
    payNow: 'Pay Now',
    paymentSuccessful: 'Payment Successful',
    paymentFailed: 'Payment Failed',
    selectMethod: 'Select Payment Method',
    cardPayment: 'Card Payment',
    mobileBanking: 'Mobile Banking',
    onlineBanking: 'Online Banking'
  },
  
  // Emergency Services
  emergency: {
    title: 'Emergency Services',
    oxygenCylinder: 'Oxygen Cylinder',
    wheelchair: 'Wheelchair',
    nurse: 'Emergency Nurse',
    bookNow: 'Book Now',
    subscribe: 'Subscribe',
    currentSubscriptions: 'Current Subscriptions',
    subscriptionPlans: 'Subscription Plans'
  },
  
  // Checkout
  checkout: {
    title: 'Checkout',
    shippingAddress: 'Shipping Address',
    orderSummary: 'Order Summary',
    total: 'Total',
    subtotal: 'Subtotal',
    discount: 'Discount',
    loyaltyPoints: 'Loyalty Points',
    useLoyaltyPoints: 'Use Loyalty Points',
    placeOrder: 'Place Order',
    couponCode: 'Coupon Code',
    applyCoupon: 'Apply Coupon'
  }
};

